import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  state:{
  	staff:{},
    tabs:[],
    clickTab:'',
    isHkServer:false,
    systemCpy:0
  },

  mutations:{
      updateIsHkServer(state){
          state.isHkServer=true;
      },
      updateSystemCpy(state,value){
          state.systemCpy=value;
      },
      clearTabs(state){
          state.tabs=[];
      },
 	  updateStaff(state,staff){
       state.staff=staff;
      },
      addTab(state,tab){
 	      var i=state.tabs.findIndex(item=>item.name==tab.name);
          if(i==-1){
            state.tabs.push(tab);
          }else{
            for(let i=0;i<state.tabs.length;i++){
              if(tab.name==state.tabs[i].name){
                  state.tabs.splice(i,1,tab);    
                  break;
              }
            }
            
          }
      },
      closeTab(state,name){


          var i=state.tabs.findIndex(item=>item.name==name);
          state.tabs.splice(i,1);
      },
      setterClickTab(state,value){
          state.clickTab = value;
      },

  },
  getters:{
      systemCpy:state=>{
            return state.systemCpy;
      },
      isHkServer:state=>{
            return state.isHkServer;
      },
      tabs:state=>{
          return state.tabs;
      },
  	 staff:state=>{
		  return state.staff;
  	 },
     permissions:state=>{
      return state.staff.permissions;
     },
     hasPermission:(state)=>(permission)=>{
         return state.staff.permissions.findIndex(item=>item===permission)>=0?true:false;
     },
     getTabs:state=>{
        return state.clickTab;
     }
  },
  actions:{

  }
})



// WEBPACK FOOTER //
// ./src/store/store.js